import { types } from "../action-types";

// import initialState from './appReducer';
const initialState = {
  loading: false,
  error: {},
  searchvalue: "",
  filters: [],
};

const myGigsFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MY_GIG_FILTERS_REQUESTED:
      return { ...state, loading: true };
    case types.MY_GIG_FILTERS_FAILURE:
      return state;
    case types.MY_GIG_FILTERS_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };
      case types.SEARCH_MY_GIGS_DYNAMIC_LOCATION_INIT:
        return {
          ...state,
          locationloading: true,
          isSuccess: false,
        };
      case types.SEARCH_MY_GIGS_DYNAMIC_LOCATION_SUCCESS:
        const value = action.payload?.value;
        const type = value?.includes('location') ? 'location' : value?.includes('region') ? 'region': value?.includes('country') ? 'country': null;
        // if(window.innerWidth < 768){
        //   return {
        //     ...state,
        //     locationloading: false,
        //     error: {},
        //     isSuccess: true,
        //     locations: (type != 'location') && action.payload.result.locationDetails?.citiesCount.length === 0 ? state.locations : action.payload.result.locationDetails?.citiesCount,
        //     stateSuggestions: (type != 'country') && action.payload.result.locationDetails?.countryCount.length === 0 ? state.stateSuggestions : action.payload.result.locationDetails?.countryCount,
        //     regionSuggestions: (type != 'region') && action.payload.result.locationDetails?.regionCount.length === 0 ? state.regionSuggestions : action.payload.result.locationDetails?.regionCount,
        //   };
        // } else{
          return {
            ...state,
            locationloading: false,
            error: {},
            isSuccess: true,
            locations: (type === 'location' || !type) ? 
                        action.payload.result.locationDetails?.citiesCount.length > 0 ? 
                        action.payload.result.locationDetails?.citiesCount 
                        : [] 
                        : state.locations,
            stateSuggestions: (type === 'country' || type === 'location' || !type) ? 
                              action.payload.result.locationDetails?.countryCount.length > 0 ? 
                                action.payload.result.locationDetails?.countryCount 
                                : [] 
                                : state.stateSuggestions,
            regionSuggestions: (type === 'region' || type === 'location' || !type ) ? 
                              action.payload.result.locationDetails?.regionCount.length > 0 ? 
                                  action.payload.result.locationDetails?.regionCount 
                                  : [] 
                                  : state.regionSuggestions,
          };
        // }
      case types.SEARCH_MY_GIGS_DYNAMIC_LOCATION_FAILURE:
        return {
          ...state,
          locationloading: false,
          isSuccess: false,
        };
        
        case types.FETCH_MY_GIGS_SEARCH_SKILLS_INIT:
          return {
            ...state,
            loadingSkills: true,
            isSuccess: false,
          };
        case types.FETCH_MY_GIGS_SEARCH_SKILLS_SUCCESS:
          return {
            ...state,
            loadingSkills: false,
            error: {},
            skills: action.payload,
          };
        case types.FETCH_MY_GIGS_SEARCH_SKILLS_FAILURE:
          return {
            ...state,
            loadingSkills: false,
            isSuccess: false,
          };
  
    default:
      return state;
  }
};

export default myGigsFilterReducer;
